import React from 'react';

import { UISiteFooter } from '../../../components/uisite/footer';
import { UISiteHeaderMenu } from '../../../components/uisite/header/menu';
import { Accordion, AccordionTab } from 'primereact/accordion';

import '../../../assets/style/pages/site/subpage/index.scss';


export const PageFAQ = (props) => {
    return (
        <div className="page-faq">
            <header>
                <UISiteHeaderMenu {...props} />
            </header>
            <section>
                <div className="content">
                    <h1>
                        FAQ
                    </h1>
                    <div>
                        <Accordion activeIndex={0}>
                            <AccordionTab header="Pergunta I">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                    ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                            </AccordionTab>
                            <AccordionTab header="Pergunta II">
                                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
                                    architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
                                    voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius modi.</p>
                            </AccordionTab>
                            <AccordionTab header="Pergunta III">
                                <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati
                                    cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.
                                    Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.</p>
                            </AccordionTab>
                        </Accordion>
                    </div>
                    <div>
                        <div className="separator"></div>
                    </div>
                    <div className="box-read-more">
                        <div className="content">
                            <div className="text">
                                Ainda está em dúvida?
                            </div>
                            <div className="button">
                                <div onClick={()=>{
                                    props.history.push('/contact');
                                }} className="read-more">
                                    Entre em contato
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer>
                <UISiteFooter {...props} />
            </footer>
        </div>
    )
}